import React from 'react';
import {
  TextField,
  ReferenceField,
  BooleanField,
  TextInput,
  SelectInput,
  DateInput,
  ReferenceInput,
  BooleanInput, FunctionField
} from 'react-admin';

import ListFilter from '../../components/poc/ListWithLayout/components/ListFilter';
import ListWithLayout from '../../components/poc/ListWithLayout';
import Actions from '../../components/poc/Grid/Row/Actions';
import {StatusField} from '../../components/poc/StatusField';

import {deletePermission, editPermission, viewPermission} from './permissions';
import {AVAILABLE_BASIC_STATUSES} from '../../app/etc/consts';

import session from '../../app/session';
import config from "../../app/etc/config";
import {formatClientName} from "../../components/poc/Grid/Fields";

const TemplateFilter = (props) => (
  <ListFilter {...props}>
    <TextInput source="id:in" label="ID"/>
    <TextInput source="name:like" label="Name"/>

    {session.hasAdminPermission() &&
      <ReferenceInput label="Client" reference="client" source="client_id" perPage={config.pagination.associated} sort={{field: 'name', order: 'ASC'}}>
        <SelectInput optionText={formatClientName}/>
      </ReferenceInput>
    }

    <SelectInput source="status"  choices={AVAILABLE_BASIC_STATUSES} />
    <BooleanInput source="is_shared"/>
    <DateInput source="created_at"/>
    <DateInput source="updated_at"/>
  </ListFilter>
);

export const TemplateGrid = (props) => {
  return (
    <ListWithLayout
      {...props}
      filters={<TemplateFilter/>}
      resource="template"
      perPage={config.pagination.grid}
      sort={{field: 'created_at', order: 'DESC'}}
      createButton={true}
    >
      <TextField source="id"/>
      <TextField source="name"/>
      <StatusField source="status"/>

      {session.hasAdminPermission() &&
        <ReferenceField label="Client" reference="client" source="client_id" sortable={false}>
          <FunctionField render={formatClientName}/>
        </ReferenceField>
      }

      <BooleanField source="is_shared"/>

      <Actions view={viewPermission} edit={editPermission} delete={deletePermission}/>
    </ListWithLayout>
  )
};
